import { useRef } from 'react';
import { Center } from '@react-three/drei'
import Island from '../assets/map/Island.jsx'
import Crashpad from '../assets/map/Crashpad.jsx'
import Trees from '../assets/map/Trees.jsx'
import Builds1 from '../assets/map/Builds1.jsx'
import Builds2 from '../assets/map/Builds2.jsx'
import Builds3 from '../assets/map/Builds3.jsx'
import Blocs from '../assets/map/Blocs.jsx'
import Lights from '../assets/map/Lights.jsx'
import Signs from '../assets/map/Signs.jsx'
import LargeHut from '../assets/map/LargeHut.jsx'
import SmallHuts from '../assets/map/SmallHuts.jsx' 
import Sideroad from '../assets/map/Sideroad.jsx' 
import LocalCenter from '../assets/map/LocalCenter.jsx' 
import TraficLights from '../assets/map/TraficLights.jsx' 
import UserLights from '../assets/map/UserLights.jsx'
import ElecLocal from '../assets/map/ElecLocal.jsx'
import Roads from '../assets/map/Roads.jsx';


export default function BaseMap({ position = [0, 0, 0], rotation = [0, 0 , 0], scale = [0, 0, 0]}) {
    const groupRef = useRef();
    return (
        <>  
            <group ref={groupRef} position={position} rotation={[0, 0 , 0]} scale={scale}>
                <Center>
                    <ElecLocal />
                    <TraficLights />
                    <UserLights />
                    <Island />
                    <Crashpad />
                    <Signs />
                    <Trees />
                    <Builds1 />
                    <Builds2 />
                    <Builds3 />
                    <SmallHuts />
                    <LargeHut />
                    <LocalCenter />
                    <Sideroad />
                    <Blocs />
                    <Lights />
                    <Roads />
                </Center>
            </group>
        </>
    )
}